import NextImage, { ImageProps } from 'next/image';

import { cn } from '@lib/utils';

function Image({ className, ...props }: ImageProps) {
  const baseClassName = 'absolute top-0 h-full w-auto min-w-full max-w-fit';

  return <NextImage {...props} className={cn(baseClassName, className)} />;
}

export default Image;
